import { addBreakpoint } from 'scripts/functions/add-breakpoint';
import { addClassToDocumentAtScrollY } from 'scripts/functions/add-class-at-scroll-y';
const html = document.documentElement;
const header = document.querySelector('.js-header');
const nav = header.querySelector('.js-header__nav');
const list = header.querySelector('.js-header__list');
addClassToDocumentAtScrollY('scrolled', 100);
addBreakpoint(html, () => nav.clientWidth < list.clientWidth, 'header-desktop', 'HeaderBreakpoint');